import React, { useState } from 'react';
import Modal from 'react-modal';
import './DocumentTable.css';
import BlogModal from './Modals/BlogModal';
import DocumentModal from './Modals/DocumentModal';
import SourceModal from './Modals/SourceModal';
import PasteModal from './Modals/PasteModal';
import ConsolidateModal from './Modals/ConsolidateModal';
import TagSelectedModal from './Modals/TagSelectedModal';
import { generateBlog, consolidate, generateKGAFromBlog, deleteDocuments} from '../api';
import Toolbar from './Toolbar';
import { update } from '../api';
import { v4 as uuid } from 'uuid';
import { FaFilter } from 'react-icons/fa';


Modal.setAppElement('#root');

function DocumentTable({ documents, setDocuments, pivotHandler, fetchAndSetDocuments, setIsLoading, showToast}) {
  const [selectedDocument, setSelectedDocument] = useState(null);
  
  //Modals
  const [documentModalOpen, setDocumentModalOpen] = useState(false);
  const [pasteModalOpen, setPasteModalOpen] = useState(false);
  const [consolidateModalOpen, setConsolidateModalOpen] = useState(false);
  const [tagSelectedModalOpen, setTagSelectedModalOpen] = useState(false);

  const [isSourceModalOpen, setIsSourceModalOpen] = useState(false);
  const [sourceInput, setSourceInput] = useState('');

  const [isBlogModalOpen, setIsBlogModalOpen] = useState(false);
  const [blogContent, setBlogContent] = useState('');


  const [questionFilter, setQuestionFilter] = useState('');
  const [answerFilter, setAnswerFilter] = useState('');
  const [sourceFilter, setSourceFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [scoreFilter, setScoreFilter] = useState('');
  const [matchedFilter, setMatchedFilter] = useState('');
  const [tagsFilter, setTagsFilter] = useState('');

  const [selectedStatus, setSelectedStatus] = useState("");


  const filteredDocuments = documents.filter(doc => {
    const filterCheck = (filter, value) => {
      if (!filter) return true;
      if (value === undefined || value === null) return false;
      return value.toString().toLowerCase().includes(filter.toLowerCase());
    };
  
    return (
      filterCheck(questionFilter, doc.question) &&
      filterCheck(answerFilter, doc.answer) &&
      // filterCheck(sourceFilter, doc.source) &&
      filterCheck(statusFilter, doc.status) &&
      filterCheck(scoreFilter, doc.score) &&
      filterCheck(matchedFilter, doc.matched) &&
      (tagsFilter ? doc.tags && doc.tags.some(tag => filterCheck(tagsFilter, tag)) : true)
    );
  });
  
  function updateDocumentInState(updatedDocument, isNew = false) {
    if (isNew) {
      setDocuments(prevDocuments => [...prevDocuments, updatedDocument]);
    } else {
      setDocuments(prevDocuments =>
        prevDocuments.map(doc =>
          doc.id === updatedDocument.id ? updatedDocument : doc
        )
      );
    }
  }

  function updateMultipleDocumentsInState(updatedDocuments) {
    setDocuments(prevDocuments =>
      prevDocuments.map(doc =>
        updatedDocuments.find(uDoc => uDoc.id === doc.id) || doc
      )
    );
  }

  function onDeleteDocuments(deletedIds) {
    setDocuments(currentDocuments => currentDocuments.filter(doc => !deletedIds.includes(doc.id)));
  }

  const handleGenerateBlog = async () => {
    const selectedCheckboxes = document.getElementsByClassName('row-select');
    const selectedDocumentIds = Array.from(selectedCheckboxes)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.getAttribute('data-id'));
  
    if (selectedDocumentIds.length === 0) {
      alert("No documents selected!");
      return;
    }
  
    const selectedDocuments = selectedDocumentIds
      .map(id => documents.find(doc => doc.id === id))
      .filter(doc => doc !== undefined);
  
    const questionsAndAnswers = selectedDocuments.map(doc => ({ question: doc.question, answer: doc.answer }));
  
    setIsLoading(true);
    setIsBlogModalOpen(true);
  
    try {
      const data = await generateBlog(questionsAndAnswers);
      setBlogContent(data.markdown);
    } catch (error) {
      console.log("Error generating blog: ", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  
  const handleSourceInputChange = (e) => {
    setSourceInput(e.target.value);
  };
  
  // This is for generating KGA's from a URL (blog)
  const handleSourceSubmit = async () => {
    setIsLoading(true);
    closeModal();
    try {
      await generateKGAFromBlog(sourceInput);
    } catch (error) {
      console.error('Error: ', error);
    }
  };
  
  const handleEditClick = (doc) => {
    setSelectedDocument(doc);
    setDocumentModalOpen(true);
  };


  const handleAdd = () => {
    const doc = { question: "", answer: "", source: "", status: "Pending", score: 0, matched: "" }
    setSelectedDocument(doc);
    setDocumentModalOpen(true);
  };
  
  //Set all modals to false. Only one should ever be open anyway.
  const closeModal = () => {
    setDocumentModalOpen(false);
    setPasteModalOpen(false);
    setConsolidateModalOpen(false);
    setTagSelectedModalOpen(false);
  };
  
  const handleSelectAll = () => {
    const selectAllCheckbox = document.getElementById('select-all');
    const checkboxes = document.getElementsByClassName('row-select');
    for (let i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = selectAllCheckbox.checked;
    }
  };

  const deselectAll = () => {
    const checkboxes = document.getElementsByClassName('row-select');
    for (let checkbox of checkboxes) {
      checkbox.checked = false;
    }
  
    const selectAllCheckbox = document.getElementById('select-all');
    if (selectAllCheckbox) {
      selectAllCheckbox.checked = false;
    }
  };
  
  const setStatus = async (status) => {
    const selectedCheckboxes = document.getElementsByClassName('row-select');
    const selectedIds = Array.from(selectedCheckboxes)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.getAttribute('data-id'));
  
    if (selectedIds.length === 0) return;
  
    const updatedDocuments = selectedIds.map(id => {
      const doc = documents.find(d => d.id === id);
      return { ...doc, status: status };
    });
  
    updateMultipleDocumentsInState(updatedDocuments);
  
    try {
      await update(updatedDocuments);
      return selectedIds.length;
    } catch (error) {
      console.error('Error updating documents:', error);
    }
  };
  
  
  const handleSetStatus = async (event) => {
    setIsLoading(true);
    var newStatus = event.target.value;
    if (!newStatus) return;
  
    if (newStatus === 'other') {
      newStatus = prompt("Please enter a new status");
    }
    try {
      const totalSelected = await setStatus(newStatus)
      if(totalSelected > 0){
        showToast('success', `Updated status for ${totalSelected} rows!`)
      }else{
        showToast('error', 'No rows selected.')
      }

    } catch (error){
      console.log('Error setting status');
      showToast('error', `Failed to update status!`)
    }
      
    //fetchAndSetDocuments();
    setSelectedStatus("");
    deselectAll();
    setIsLoading(false);
  };
  
  const handleExportCSV = () => {
    try{
      const checkboxes = document.getElementsByClassName('row-select');
      const selectedDocuments = [];
      for (let i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          const docId = checkboxes[i].getAttribute('data-id');
          const doc = documents.find(d => d.id === docId);
          if (doc) {
            selectedDocuments.push(doc);
          }
        }
      }
    
      if (selectedDocuments.length === 0) {
        showToast('error', 'No rows selected.')
        return;
      }
    
      const csvRows = ['question,answer,source,status,score,matched'];
      for (const doc of selectedDocuments) {
        const row = [
          `"${doc.question.replace(/"/g, '""')}"`,
          `"${doc.answer.replace(/"/g, '""')}"`,
          // `"${doc.source.replace(/"/g, '""')}"`,
          `"${doc.status}"`,
          `"${doc.score}"`,
          `"${doc.matched}"`
        ];
        csvRows.push(row.join(','));
      }
      const csvString = csvRows.join('\n');
    
      const blob = new Blob([csvString], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.setAttribute('hidden', '');
      a.setAttribute('href', url);
      a.setAttribute('download', 'export.csv');
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      deselectAll();
      showToast('success', `Exported ${selectedDocuments.length} rows to CSV!`);
    }catch (error){
      console.log(error);
      showToast('error', "Failed to export as CSV.");
    }
    
  };
  
  
  const handleDelete = async () => {
    setIsLoading(true);
    const checkboxes = document.getElementsByClassName('row-select');
    const selectedIds = Array.from(checkboxes)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.getAttribute('data-id'));
  
    console.log("Selected IDs: ", selectedIds);
    
    if (selectedIds.length > 0) {
      try {
        const response = await deleteDocuments(selectedIds);
        onDeleteDocuments(selectedIds);
        showToast('success', `Successfully deleted ${selectedIds.length} rows!`);
      } catch (error) {
        console.error('Error deleting documents:', error);
        showToast('error', 'Error deleted rows.');
      }
    }else{
      showToast('error', 'No rows selected.');
    }
    deselectAll();
    setIsLoading(false);
  };
  
  
  const handleCopy = () => {
    try{
      const checkboxes = document.getElementsByClassName('row-select');
      const Q_and_A = [];
      for (let i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          const docId = checkboxes[i].getAttribute('data-id');
          const doc = documents.find(d => d.id === docId);
          if (doc) {
            Q_and_A.push({ question: doc.question, answer: doc.answer });
          }
        }
      }
      const Q_and_A_string = JSON.stringify(Q_and_A, null, 2);
      navigator.clipboard.writeText(Q_and_A_string);
      deselectAll();
      if(Q_and_A.length > 0){
        showToast('success', `Successfully copied ${Q_and_A.length} rows to clipboard!`)
      }else{
        showToast('error','No rows selected.')  
      }
    }catch (error){
      console.log(error);
      showToast('error','Error copying selected rows.')
    }
  };
  
  const handleBulkConsolidate = async () => {
    setConsolidateModalOpen(true);
  }
  
  const handleBulkConsolidateSubmit = async (tags) => {
    setConsolidateModalOpen(false);
    setIsLoading(true);
    setStatus("Consolidating");
  
    const checkboxes = document.getElementsByClassName('row-select');
    const Q_and_A = [];
  
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        const docId = checkboxes[i].getAttribute('data-id');
        const doc = documents.find(d => d.id === docId);
        if (doc) {
          Q_and_A.push({
            id: doc.id,
            question: doc.question, 
            answer: doc.answer
          });
        }
      }
    }
    if(Q_and_A.length > 30){
      showToast('error', 'Select 30 or less KGA\'s to consolidate');
      setIsLoading(false);
      return;
    }
  
    if (Q_and_A.length > 0) {
      try {
        const result = await consolidate(Q_and_A, tags.split(',').map(tag => tag.trim()));
        
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        if (result.success) {
            try {
                await fetchAndSetDocuments();
            } catch (fetchError) {
                console.error('Error fetching documents:', fetchError);
            }
            
            showToast('success', `Successfully queued ${result.original_count} KGA's for consolidation!`);
        }
    } catch (error) {
        console.error('Error consolidating documents:', error);
        showToast('error', 'Error consolidating documents');
    } finally {
        deselectAll();
        setIsLoading(false);
    }
    } else {
      showToast('error', 'No rows selected.')
      deselectAll();
      setIsLoading(false);
    }
  };
  
  
  const handleGenerateConsolidatePrompt = () => {
    try {
      const checkboxes = document.getElementsByClassName('row-select');
      const Q_and_A = [];
      for (let i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          const docId = checkboxes[i].getAttribute('data-id');
          const doc = documents.find(d => d.id === docId);
          if (doc) {
            Q_and_A.push({ question: doc.question, answer: doc.answer });
          }
        }
      }
      if(Q_and_A.length === 0){
        showToast('error', 'No rows selected.');
        return;
      }
      const prompt = `Please consolidate these Q&A entries into a smaller set of questions
        with thorough answers. Use all of the information contained in the consolidated entries for the answers. It
        is okay if there remains some overlap in the questions as long as the questions are semantically different in some way.
        The output should a JSON string in a code block that matches the input structure with no other text.\n`;
    
      const Q_and_A_string = JSON.stringify(Q_and_A, null, 2);
      navigator.clipboard.writeText(prompt + Q_and_A_string);
      showToast('success', 'Prompt copied to clipboard!');
    }catch (error){
      console.log(error);
      showToast('error', 'Failed to generate prompt.');
    }finally{
      deselectAll();
    }
    
  };
  
  const getScoreClass = (score) => {
    if (isNaN(score)) {
      return '';
    } else if (score < 0.5) {
      return 'score-low';
    } else if (score < 0.85) {
      return 'score-medium';
    } else {
      return 'score-high';
    }
  };

  const handleRefresh = async () => {
    setIsLoading(true);
    await fetchAndSetDocuments();
    deselectAll();
    setIsLoading(false);
  }

  const handleTagSelected = () => {
    setTagSelectedModalOpen(true);
  }

  const handleTagSelectedSubmit = async (tagsString) => {
    closeModal();
    setIsLoading(true);
    const newTags = tagsString.split(',').map(tag => tag.trim()).filter(tag => tag);

    const selectedCheckboxes = document.getElementsByClassName('row-select');
    const selectedDocumentIds = Array.from(selectedCheckboxes)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.getAttribute('data-id'));

    const selectedDocuments = documents.filter(doc => selectedDocumentIds.includes(doc.id));
  
    const updatedDocuments = selectedDocuments.map(doc => {
        const existingTags = doc.tags || [];
        const combinedTags = [...new Set([...existingTags, ...newTags])];
        return { ...doc, tags: combinedTags };
    });
    updateMultipleDocumentsInState(updatedDocuments);
    try {
        await update(updatedDocuments);
        showToast('success', `Tags added to ${updatedDocuments.length} KGA${updatedDocuments.length !== 1 ? 's' : ''}`);
    } catch (error) {
        console.error('Error updating documents with new tags:', error);
        showToast('error', 'Error updating documents with new tags');
    } finally {
        setIsLoading(false);
        deselectAll();
    }
};

  
  const handlePasteQAPairs = () => {
    setPasteModalOpen(true);
  };

  const handleSubmitPasteQA = async (input, tags, isError) => {
    if (isError) {
      console.log("Cannot submit due to errors in the data");
      showToast('error', 'Cannot submit due to errors in the data');
      return;
    }
    const formattedDocuments = input.map(doc => {
      return {
          ...doc,
          id: uuid(),
          tags: tags.split(',').map(tag => tag.trim()),
          status: "New",
          source: ""
      };
    });
    
    try {
      setIsLoading(true);
      closeModal();
      
      await update(formattedDocuments);
      //updateMultipleDocumentsInState(formattedDocuments); //Why doesnt this work....
      const newFormattedDocuments = formattedDocuments.map(doc => ({ ...doc, id: uuid() }));
      setDocuments(prevDocuments => [
        ...prevDocuments,
        ...newFormattedDocuments
      ]);
      
      showToast('success', `Successfully added ${formattedDocuments.length} KGA${formattedDocuments.length !== 1 ? 's' : ''}`);
    } catch (error) {
      console.error('Error adding new QA', error);
      showToast('error', 'Error adding new documents');
    } finally {
      setIsLoading(false);
    }
}

  
  return (
    <div className="table-container">
      <Toolbar
        handleRefresh={handleRefresh}
        handleAdd={handleAdd}
        handleDelete={handleDelete}
        handleGenerateConsolidatePrompt={handleGenerateConsolidatePrompt}
        handlePasteQAPairs={handlePasteQAPairs}
        handleCopy={handleCopy}
        handleBulkConsolidate={handleBulkConsolidate}
        handleExportCSV={handleExportCSV}
        selectedStatus={selectedStatus}
        handleSetStatus={handleSetStatus}
        handleTagSelected={handleTagSelected}
      />

      <TagSelectedModal
        tagSelectedModalOpen={tagSelectedModalOpen}
        closeModal={closeModal}
        handleTagSelectedSubmit={handleTagSelectedSubmit}
      />

      <PasteModal
        pasteModalOpen={pasteModalOpen}
        closeModal={closeModal}
        handleSubmitPasteQA={handleSubmitPasteQA}
      />
  
      <BlogModal
        isBlogModalOpen={isBlogModalOpen}
        setIsBlogModalOpen={setIsBlogModalOpen}
        blogContent={blogContent}
      />
  
      <SourceModal
        isSourceModalOpen={isSourceModalOpen}
        closeModal={closeModal}
        sourceInput={sourceInput}
        handleSourceInputChange={handleSourceInputChange}
        handleSourceSubmit={handleSourceSubmit}
      />
  
      <DocumentModal
        documentModalOpen={documentModalOpen}
        closeModal={closeModal}
        selectedDocument={selectedDocument}
        setIsLoading={setIsLoading}
        updateDocumentInState={updateDocumentInState}
      />

      <ConsolidateModal
        consolidateModalOpen={consolidateModalOpen}
        closeModal={closeModal}
        setIsLoading={setIsLoading}
        fetchAndSetDocuments={fetchAndSetDocuments}
        handleBulkConsolidateSubmit={handleBulkConsolidateSubmit}
      />
  
      <p>{filteredDocuments.length} entries.</p>
      <table className="document-table">
        <thead>
          <tr>
            <th className="select-column">
              <input type="checkbox" id="select-all" onChange={handleSelectAll} />
            </th>
            <th className={`question-column ${questionFilter ? 'active-filter-header' : ''}`}>
              <div className="column-head">
                Question
                {questionFilter && <FaFilter className="active-filter-icon" />}
              </div>
              <input
                type="text"
                className="filter-input"
                value={questionFilter}
                onChange={(e) => setQuestionFilter(e.target.value)}
                placeholder="Filter Question"
              />
            </th>
            <th className={`answer-column ${answerFilter ? 'active-filter-header' : ''}`}>
              <div className="column-head">
                Answer
                {answerFilter && <FaFilter className="active-filter-icon" />}
              </div>
              <input
                type="text"
                className="filter-input"
                value={answerFilter}
                onChange={(e) => setAnswerFilter(e.target.value)}
                placeholder="Filter Answer"
              />
            </th>
            {/* <th className={`source-column ${sourceFilter ? 'active-filter-header' : ''}`}>
              <div className="column-head">
                Source
                {sourceFilter && <FaFilter className="active-filter-icon" />}
              </div>
              <input
                type="text"
                className="filter-input"
                value={sourceFilter}
                onChange={(e) => setSourceFilter(e.target.value)}
                placeholder="Filter Source"
              />
            </th> */}
            <th className={`status-column ${statusFilter ? 'active-filter-header' : ''}`}>
              <div className="column-head">
                Status
                {statusFilter && <FaFilter className="active-filter-icon" />}
              </div>
              <input
                type="text"
                className="filter-input"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                placeholder="Filter Status"
              />
            </th>
            <th className={`tags-column ${tagsFilter ? 'active-filter-header' : ''}`}>
              <div className="column-head">
                Tags
                {tagsFilter && <FaFilter className="active-filter-icon" />}
              </div>
              <input
                type="text"
                className="filter-input"
                value={tagsFilter}
                onChange={(e) => setTagsFilter(e.target.value)}
                placeholder="Filter Tags"
              />
            </th>
            <th className={`score-column ${scoreFilter ? 'active-filter-header' : ''}`}>
              <div className="column-head">
                Score
                {scoreFilter && <FaFilter className="active-filter-icon" />}
              </div>
              <input
                type="text"
                className="filter-input"
                value={scoreFilter}
                onChange={(e) => setScoreFilter(e.target.value)}
                placeholder="Filter Score"
              />
            </th>
            <th className={`matched-column ${matchedFilter ? 'active-filter-header' : ''}`}>
              <div className="column-head">
                Matched
                {matchedFilter && <FaFilter className="active-filter-icon" />}
              </div>
              <input
                type="text"
                className="filter-input"
                value={matchedFilter}
                onChange={(e) => setMatchedFilter(e.target.value)}
                placeholder="Filter Matched"
              />
            </th>
            <th className="edit-column">
              <div className="column-head">Actions</div>
              <div className="invisible-spacer"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredDocuments.map((doc) => (
            <tr key={doc.id}>
              <td>
                <input type="checkbox" className="row-select" data-id={doc.id} />
              </td>
              <td className="question-column">{doc.question}</td>
              <td className="answer-column">{doc.answer}</td>
              {/* <td className="source-column">
                <a href={doc.source} target="_blank" rel="noopener noreferrer">
                  {doc.source}
                </a>
              </td> */}
              <td className="text-center status-column">{doc.status}</td>
                <td className="text-center tags-column">{doc.tags?.join(', ') || ''}</td>
                <td className={`text-center score-cell score-column ${getScoreClass(doc.score)}`}>
                {isNaN(doc.score) ? '' : Math.floor(doc.score * 100)}
              </td>
              <td className="text-center matched-column">
                {doc.matched}
              </td>
              <td className="action-buttons">
                <button className="action-button" onClick={() => handleEditClick(doc)}>
                  Edit
                </button>
                <button className="action-button" onClick={() => pivotHandler(doc)}>
                  Pivot
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
  
  
}
export default DocumentTable;